// extracted by mini-css-extract-plugin
module.exports = {"heading":"TraitsHeading_heading__UIEG3","headerProfile":"TraitsHeading_headerProfile__A0V_h","headerNoProfile":"TraitsHeading_headerNoProfile__MW5H9"};